import { getShortDate } from "library/helpers/events/dateSets";

import * as st from './styles.module.scss';

export const EventDateTime = ({ date, timeRange }: { date: string; timeRange: string }) => {

    return (
        <div className={st.date}>
            <span>{getShortDate(date)}</span>
            <span>{timeRange}</span>
        </div>
    )
}